const CDN = "https://images.squarespace-cdn.com/content/v1/5e1fdc831acd51128a859d90";

export const SITE = {
  name: "Chinook K9",
  tagline: "Certified Professional Dog Training",
  phone: "403-715-0499",
  phoneHref: "tel:+14037150499",
  email: "training@chinookk9.com",
  address: "263001 Lochend Road, Rocky View County, AB",
  hours: "Monday to Sunday, 7:00 AM – 8:00 PM",
  instagram: "https://www.instagram.com/chinookk9/",
  facebook: "https://www.facebook.com/chinookK9/",
  logo: `${CDN}/1579316437008-8PPTAXEPD6K8MQQH3QPU/CK9+W_R.png`,
};

export const VIDEO_URL = "/hero-video.mp4";

export const IMG = {
  heroPoster:
    "https://images.unsplash.com/photo-1596278852720-141ba859bbbf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxkb2clMjB0cmFpbmluZyUyMGFjdGlvbnxlbnwwfHx8fDE3ODc1ODUxOTZ8MA&ixlib=rb-4.1.0&q=85",
  boardTrain: `${CDN}/58086d3e-ca52-4e8d-8a29-10274ecfdcaf/FR7A8293.JPG?format=1000w`,
  privateTraining: `${CDN}/c6d2de31-9dd7-4e99-9717-a0f286034f62/FR7A8540.JPG?format=1000w`,
  jumpstart: `${CDN}/24735cc2-4cba-44e3-8b7b-ec3720d3f807/tempImagegSOeF6.jpg?format=1000w`,
  boardTrainWide: `${CDN}/90366585-1a21-4bc9-a03e-43a54db84df4/FR7A7589.jpg?format=1500w`,
  privateWide: `${CDN}/5b5c2612-8e3d-4cff-8100-1eefefafe0ef/FR7A7628.jpg?format=1500w`,
  jumpstartWide: `${CDN}/0fd4f4a2-8370-484d-9fa5-80192820f34c/tempImageYcgQFI.jpg?format=1500w`,
  philosophy: "https://customer-assets-gfyr7b9c.emergentagent.net/job_dog-trainer-yeg/artifacts/rjx0uvk3_image.png",
  virtualLessons: "/virtual-lessons.jpg",
  calgary:
    "https://images.unsplash.com/photo-1629477810810-0c4159eaa575?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxjYWxnYXJ5JTIwc2t5bGluZXxlbnwwfHx8fDE3ODc1ODUxOTZ8MA&ixlib=rb-4.1.0&q=85",
  gallery: [
    `${CDN}/1733335260122-94VIHK5B7BYHNNGP8A55/image-asset.jpeg?format=750w`,
    `${CDN}/1731902862677-8O1T47X59UT7QJQM8IK5/image-asset.jpeg?format=750w`,
    `${CDN}/1731170510249-6U2WLMNF6D1SK2JR48NN/image-asset.jpeg?format=750w`,
    `${CDN}/1728501638092-WX8LUNLUC7FMS3QL5MW2/image-asset.jpeg?format=750w`,
  ],
};

export const PROGRAM_OPTIONS = [
  "Board and Train",
  "Private Training",
  "Virtual Lessons",
  "Jumpstart Program",
  "I don't know yet!",
];

export const REFERRAL_OPTIONS = ["Google", "Instagram", "Facebook", "Word of Mouth", "Website", "Other"];

export const CITIES = [
  {
    slug: "calgary",
    name: "Calgary",
    hero: `${CDN}/1733335260122-94VIHK5B7BYHNNGP8A55/image-asset.jpeg?format=1500w`,
    intro:
      "Chinook K9 provides certified professional dog training to Calgary families from our facility just outside the city. Whether you're walking the pathways of Nose Hill, visiting off-leash parks, or just want a calm companion at home, our board & train and private training programs are built around your goals.",
    hook: "From downtown patios to off-leash parks, we help Calgary dogs become calm, reliable companions anywhere in the city.",
  },
  {
    slug: "airdrie",
    name: "Airdrie",
    hero: IMG.gallery[0],
    intro:
      "Just a short drive south of Airdrie, Chinook K9's facility is the trusted choice for Airdrie dog owners dealing with pulling, reactivity, barking, or a brand-new puppy. Our immersive board & train programs and one-on-one private lessons deliver real, lasting results.",
    hook: "Airdrie's growing neighbourhoods deserve well-mannered dogs — we make it happen.",
  },
  {
    slug: "cochrane",
    name: "Cochrane",
    hero: IMG.gallery[1],
    intro:
      "Chinook K9 is located minutes from Cochrane, making us the closest professional board & train facility for Cochrane dog owners. From river-pathway leash manners to off-leash reliability in the foothills, our certified trainers build dogs you can take anywhere.",
    hook: "Foothills adventures start with reliable obedience — train with Cochrane's local experts.",
  },
  {
    slug: "okotoks",
    name: "Okotoks",
    hero: IMG.gallery[2],
    intro:
      "Okotoks dog owners trust Chinook K9 for behaviour modification, puppy foundations, and off-leash obedience. Our board & train programs give your dog round-the-clock professional training, and our go-home coaching ensures the results stick when they return to your Okotoks home.",
    hook: "Sheep River walks are better with a dog that listens — we'll get you there.",
  },
  {
    slug: "chestermere",
    name: "Chestermere",
    hero: IMG.gallery[3],
    intro:
      "From lakeside walks to busy community pathways, Chestermere dogs need reliable manners. Chinook K9's certified trainers deliver immersive board & train programs and private lessons that transform pulling, jumping, and reactivity into calm, confident behaviour.",
    hook: "Lake-life ready dogs start with professional training at Chinook K9.",
  },
];

export const BEHAVIOURS = [
  "Jumping",
  "Barking",
  "Aggression (human and/or dog)",
  "Leash manners",
  "Basic obedience",
  "Counter surfing",
  "Crate training",
  "Anxiety",
  "Reactivity",
  "Off-leash reliability",
];
